import { render, staticRenderFns } from "./GroupButtons.vue?vue&type=template&id=13d1d048&scoped=true&"
import script from "./GroupButtons.vue?vue&type=script&lang=ts&"
export * from "./GroupButtons.vue?vue&type=script&lang=ts&"
import style0 from "./GroupButtons.vue?vue&type=style&index=0&id=13d1d048&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d1d048",
  null
  
)

export default component.exports